import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to rename an existing issue status entity.
 */
export class RenameIssueStatusCommand extends AbstractCommand<IssueStatus> {

    public name = CommandName.RENAME_ISSUE_STATUS;

    public tags: string[] = [`entity`, `update`, `issue-status`];

    constructor(payload: IssueStatus) {
        super('issue-status', payload.uid, payload);
    }
}
